import { render, staticRenderFns } from "./ActivationComments.vue?vue&type=template&id=7825fc6b&scoped=true&"
import script from "./ActivationComments.ts?vue&type=script&lang=ts&"
export * from "./ActivationComments.ts?vue&type=script&lang=ts&"
import style0 from "./ActivationComments.scss?vue&type=style&index=0&id=7825fc6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7825fc6b",
  null
  
)

export default component.exports